import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import React, { useRef, useState } from 'react';
import { fetchdata, viewdata } from './../reduxactions/organizationactions/OrgNeedsActions';
import { useNavigate } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { Panel } from 'primereact/panel';
import { GFNButton } from '../ui';

const OrganizationNeeds = () => {
    const uid = window.sessionStorage.getItem('uid');
    const [globalFilter, setGlobalFilter] = useState('')

    const dispatch = useDispatch();

    useEffectOnce(() => {
        const fetchDataAsync = async () => {
            try {
                await dispatch(fetchdata(uid) as any);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchDataAsync();
    }, [dispatch]);

    const navigate = useNavigate();
    //To open view
    const orgaddneed = (rowData: any) => {
        const url = `/addneeds`;
        console.log('Row ID:', rowData.userid
        );
        // Use navigate to navigate to the URL
        navigate(url);
    };

    const data = useSelector((state: RootState) => state.orgneed.data);
    const dataview = useSelector((state: RootState) => state.orgneed.dataview);

    // const navigate = useNavigate();

    const [acceptfield, setfield] = useState(false);
    const cancelfield = () => {
        setfield(false);
    }

    const viewuploaddata = (rowData: any) => {

        assignData.current = { Id: rowData.Id }

        setfield(true);
        fetchDataAsyncdialog();
    };
    const assignData = useRef({ Id: '' })

    const fetchDataAsyncdialog = async () => {
        try {
            const { Id } = assignData.current;
            console.log("Id", Id)
            dispatch(viewdata(Id) as any);
        } catch (error) {
            console.error('Error deleting data:', error);
        }
    };

    const View = (rowData: any) => {
        const url = `/latestneedsview/${rowData.Id}`;
        console.log('Row ID:', rowData.Id);
        navigate(url);
    };

    //To open view
    const handleButtonClick = (rowData: any) => {
        const url = `/orgeditneeds/${rowData.Id}`;
        console.log('Row ID:', rowData.Id);

        // Use navigate to navigate to the URL
        navigate(url);
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/org-needs.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Needs</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        <Panel>
                            <div className="grid">
                                <div className="col-12">
                                    <div className="card card-primary">
                                        <div className="card flex flex-wrap justify-content-end">
                                            {/* <Button label="Add Needs" data-testid="add-needs-btn" severity="info" onClick={() => orgaddneed(true)} /> */}
                                            <GFNButton label="Add Needs" data-testid="add-needs-btn" buttonType="primary" onClick={() => orgaddneed(true)} rounded />
                                        </div>
                                        <div className="card flex flex-wrap justify-content-end my-2">
                                            <span className="p-input-icon-left">
                                                <i className="pi pi-search ml-2" />
                                                <InputText
                                                    className="app-search-input"
                                                    value={globalFilter}
                                                    onChange={(e) => setGlobalFilter(e.target.value)}
                                                    placeholder="Global Search"
                                                />
                                            </span>
                                        </div>
                                        <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                            <Column field="needtype" sortable header="Need Type"></Column>
                                            <Column field="needtittle" sortable header="Need Title"></Column>
                                            <Column field="description" sortable header="Description"></Column>
                                            <Column field="budget_amount" sortable header="Amount"></Column>
                                            <Column field="status" sortable header="Status"></Column>
                                            <Column header="Operation" body={(rowData, { rowIndex }) => (
                                                <>
                                                    {/* <Button icon="pi pi-eye" tooltip="View" data-testid={`view-btn-${rowIndex}`} rounded outlined className='ml-1' onClick={() => View(rowData)} style={{
                                                        color: 'blue', width: '2rem', height: '2rem'
                                                    }} tooltipOptions={{ position: 'left' }} />
                                                    <Button tooltip="Edit" rounded outlined className='ml-1' icon="pi pi-pencil" data-testid={`edit-btn-${rowIndex}`} onClick={() => handleButtonClick(rowData)} aria-label="Edit" style={{ color: 'mediumseagreen', width: '2rem', height: '2rem' }} tooltipOptions={{ position: 'left' }} />
                                                    {rowData.count === 'show' && (
                                                        <span>
                                                            <Button icon="pi pi-user" data-testid={`show-btn-${rowIndex}`} aria-label="ViewDetails" tooltip="Donors" rounded outlined className="ml-1" onClick={() => viewuploaddata(rowData)} style={{ color: 'blueviolet', width: '2rem', height: '2rem' }} tooltipOptions={{ position: 'left' }} />
                                                        </span>
                                                    )} */}
                                                    <GFNButton icon="pi pi-eye" tooltip="View" data-testid={`view-btn-${rowIndex}`} buttonType="primary" rounded onClick={() => View(rowData)} className="mr-3" />
                                                    <GFNButton tooltip="Edit" buttonType="success" rounded className='mr-3' icon="pi pi-pencil" data-testid={`edit-btn-${rowIndex}`} onClick={() => handleButtonClick(rowData)} aria-label="Edit" />
                                                    {rowData.count === 'show' && (
                                                        <span>
                                                            <GFNButton icon="pi pi-user" data-testid={`show-btn-${rowIndex}`} aria-label="ViewDetails" tooltip="Donors" rounded className="mr-3" onClick={() => viewuploaddata(rowData)} />
                                                        </span>
                                                    )}
                                                </>
                                            )} />
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        {/*Assign DIALOG */}
                        <Dialog header="View Donors" style={{ width: '50vw' }} visible={acceptfield} onHide={cancelfield}>
                            <DataTable value={dataview} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>

                                <Column header="Donor Name" body={(rowData) => (
                                    <span>{rowData.firstname} {rowData.lastname}</span>
                                )}></Column>

                            </DataTable>
                            <Button label="Close" onClick={cancelfield} data-testid="close-btn" severity="secondary" />
                        </Dialog>

                    </div>
                </div>
            </div>
        </div>
    )

}
export default OrganizationNeeds


